import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ForgotPassword from './ForgotPassword';
import { LogoMarca } from '../../../components/logo';
import { UsuarioViewProps } from '../../usuario/usuario.controller';
import Alerts from '../../../components/alerts/Alerts';
import { CardHeader, CardMedia, IconButton, Stack } from '@mui/material';
import { Logout } from '@mui/icons-material';


const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

export default function SignInCard(props: UsuarioViewProps) {
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (data: any) => {
    if (emailError || passwordError) {
      return;
    }


    console.log({
      email: data.email,
      password: data.password
    });
    props.usuarioActions.login(data.email, data.password)
  };

  const validateInputs = () => {
    const email = document.getElementById('email') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;

    let isValid = true;

    /*     if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
          setEmailError(true);
          setEmailErrorMessage('Digite um email válido.');
          isValid = true;
        } else {
          setEmailError(false);
          setEmailErrorMessage('');
        } */

    if (!password.value) {
      setPasswordError(true);
      setPasswordErrorMessage('Informe a senha');
      isValid = true;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }
    if (isValid) {
      handleSubmit({ email: email.value, password: password.value })
    }
    return isValid;
  };

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      sx={{
        justifyContent: 'center',
        gap: { xs: 6, sm: 12 },
        p: 2,
        mx: 'auto',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          justifyContent: 'center',
          gap: { xs: 6, sm: 12 },
          p: { xs: 2, sm: 4 },
          m: 'auto',
          alignItems: "center"
        }}
      >
        <Card variant="outlined">
          <CardMedia sx={{display:"flex", justifyContent:"center"}}>
            <LogoMarca />
          </CardMedia>

          <CardHeader 
            title={"Conta"} 
            subheader={props.statusAppState.credencial.name} 
            action={
              <IconButton title='Desconectar da conta' onClick={props.statusAppActions.logOut}>
                <Logout />
              </IconButton>
            }
          />

          <Box
            sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
          >
            <FormControl>
              <FormLabel htmlFor="email">Login Usuário</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="seu login de acesso"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControl>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel htmlFor="password">Senha</FormLabel>
              </Box>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
            <Button fullWidth variant="contained" onClick={validateInputs}>
              Confirmar
            </Button>
          </Box>
          <Typography alignSelf={"end"} variant='caption'>Versão {props.statusAppState.versao}</Typography>
          <Alerts show={props.usuarioState.showAlert} handleClose={() => props.usuarioActions.setShowAlert(false)} menssage={props.usuarioState.msg} tipoAlerta='error' />
        </Card>
      </Stack>
    </Stack>
  );
}
